import React from 'react';
import { useAppContext } from '../../app/AppContext';
import { LoadingLabel } from '../../../shared/components/Loading';
import { useAboutMeQuery } from '../../generated.graphql';
import { AboutMeForm } from './AboutMeForm';
import { RentalStepProps } from 'rental/app/steps';


interface Props extends RentalStepProps {

}


export const AboutMe = (props: Props) => {
  const app = useAppContext();
  
  const [result,] = useAboutMeQuery({variables: {portalSlug: app.portalSlug}})
  const application = result.data?.portal?.myApplication;

  if (result.error) {
    return <div>AboutMeContainer Error</div>
  }
  if (application) {
    return <AboutMeForm {...props} application={application} portalSlug={app.portal.slug} titleEnum={result.data?.salutationSourceEnum} />
  }
  else {
    return <LoadingLabel />
  }
}
